import Immutable from 'immutable'
import { RootStateOrAny } from 'react-redux'

import { getBasket } from 'selectors/root'
import { getUserOrders } from 'selectors/user'

export const getBoxSummaryTextProps = (
  state: RootStateOrAny,
  tempDate: string,
  tempSlotId: string,
  tempOrderId: string,
  slots: Record<string, { coreSlotId: string; value: string }[]>,
): {
  deliveryLocationText: string
  slotId: string
  buttonText: string
  showWarning: boolean
} => {
  const userOrders = getUserOrders(state) as Immutable.List<Immutable.Map<string, unknown>>

  const basket = getBasket(state)
  const postcode = basket.get('postcode') as string
  const address = basket.get('address') as Immutable.Map<string, unknown>
  const basketRecipeNo = basket.get('recipes', Immutable.Map({})).size as number
  const prevSlotId = basket.get('prevSlotId') as string

  let deliveryLocationText = address ? `Address: ${address.get('name')}` : `${postcode}`
  let buttonText = prevSlotId ? 'Update delivery date' : 'Continue'

  let showWarning = false

  if (!tempOrderId) {
    return { deliveryLocationText, slotId: tempSlotId, buttonText, showWarning }
  }

  const chosenOrder = userOrders.find((order) => order?.get('id') === tempOrderId, Immutable.Map())

  const orderAddressName = chosenOrder.getIn(['shippingAddress', 'name'], null)
  if (orderAddressName) {
    deliveryLocationText = `Address: ${orderAddressName}`
  }

  const slotFind = slots[tempDate].filter(
    (slot) => slot.coreSlotId === chosenOrder.get('deliverySlotId'),
  )

  const slotId = slotFind && slotFind.length ? slotFind[0].value : ''

  const noOfRecipesInOrder = (
    chosenOrder.get('recipeItems', Immutable.List()) as Immutable.List<unknown>
  ).size

  buttonText = 'Choose recipes'
  if (noOfRecipesInOrder > 0) {
    buttonText = 'Edit recipes'
    if (basketRecipeNo > 0) {
      showWarning = true
    }
  }

  return { deliveryLocationText, slotId, buttonText, showWarning }
}
